import {
  QueryDocumentSnapshot,
  Timestamp,
  type DocumentData,
  type SnapshotOptions
} from 'firebase/firestore'
import { convertTimestampsToDates, FirebaseProperties } from '../Helper/FirebaseProperties'
import type { ObjectSummary } from '../Helper/Interfaces'
import { FirebaseCollections, FirestorePaths } from '@/utils/firestore/FirestorePaths'

export class Lead extends FirebaseProperties {
  name = ''
  phone = ''
  email = ''
  isActive = true
  recontactDate: Date | null = null
  notes = ''
  instructor: ObjectSummary | null = null

  constructor(data?: Partial<Lead>) {
    super()
    Object.assign(this, data)
  }

  setStore(storeId: string) {
    const id = this.firebaseInfo?.__id

    this.thisCollection = FirestorePaths.storeCollection(storeId, FirebaseCollections.Leads)

    this.thisDocument = id
      ? FirestorePaths.storeDocument(storeId, FirebaseCollections.Leads, id)
      : this.thisCollection
  }

  getName(): string {
    return this.name
  }

  getId(): string {
    return this.firebaseInfo.__id
  }

  getActive(): boolean {
    return this.isActive
  }

  createCopy(): Lead {
    return new Lead({
      ...this,
      firebaseInfo: { ...this.firebaseInfo }
    })
  }

  getSearchables(): string {
    return `${this.phone} ${this.email} ${this.getName()}`.trim()
  }
}

export const LeadConverter = {
  toFirestore: (lead: Lead) => {
    const firebaseInfo = {
      ...lead.firebaseInfo,
      _updatedAt: Timestamp.now()
    }

    return {
      name: lead.name,
      phone: lead.phone,
      email: lead.email,
      isActive: lead.isActive,
      recontactDate: lead.recontactDate,
      notes: lead.notes,
      instructor: lead.instructor,
      firebaseInfo
    }
  },

  fromFirestore: (
    snapshot: QueryDocumentSnapshot<DocumentData, DocumentData>,
    options?: SnapshotOptions
  ) => {
    const data = snapshot.data(options)
    return new Lead(convertTimestampsToDates(data))
  }
}
